import { useLocation, Link, NavLink } from 'react-router-dom';
import React, { forwardRef } from 'react';

export const CustomLink = forwardRef(({ to, preserveProjectId = true, ...props }, ref) => {
  const location = useLocation();
  const currentParams = new URLSearchParams(location.search);
  const currentProjectId = currentParams.get('projectId');

  let finalTo = to;

  if (preserveProjectId && typeof to === 'string') {
    const toUrl = new URL(to, window.location.origin);
    const toParams = new URLSearchParams(toUrl.search);
    if (!toParams.get('projectId') && currentProjectId) {
      toParams.set('projectId', currentProjectId);
      toUrl.search = toParams.toString();
    }
    finalTo = toUrl.pathname + '?' + toUrl.searchParams.toString();
  }

  return <Link ref={ref} to={finalTo} {...props} />;
});

export const CustomNavLink = forwardRef(({ to, preserveProjectId = true, ...props }, ref) => {
  const location = useLocation();
  const currentParams = new URLSearchParams(location.search);
  const currentProjectId = currentParams.get('projectId');

  let finalTo = to;

  if (preserveProjectId && typeof to === 'string') {
    const toUrl = new URL(to, window.location.origin);
    const toParams = new URLSearchParams(toUrl.search);
    if (!toParams.get('projectId') && currentProjectId) {
      toParams.set('projectId', currentProjectId);
      toUrl.search = toParams.toString();
    }
    finalTo = toUrl.pathname + '?' + toUrl.searchParams.toString();
  }

  return <NavLink ref={ref} to={finalTo} {...props} />;
});
